import LegalLayout from "@/components/LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutz" eyebrow="Legal · DSGVO">
      <section className="space-y-10 text-white/80 font-body text-base leading-relaxed">

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            1. Einleitung
          </h2>
          <p>
            Mit den folgenden Hinweisen informieren wir dich über die Verarbeitung deiner personen­bezogenen
            Daten gemäß Datenschutz-Grundverordnung (DSGVO) und Bundesdatenschutzgesetz (BDSG) bei der Nutzung
            unserer Website <span className="text-white">kirchero.store</span>.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            2. Verantwortlicher
          </h2>
          <p className="whitespace-pre-line">
{`VHP Consulting GmbH
Geschäftsführer: Matthias Kirchner
Lützner Straße 214
04179 Leipzig
Deutschland

Telefon: +49 341 5502441
E-Mail:  kontakt@vhp-consulting.com`}
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            3. Hosting & Server-Logs
          </h2>
          <p>
            Diese Website wird auf einem dedizierten Server der Contabo GmbH (Aschauer Straße 32a, 81549 München,
            Deutschland) gehostet. Es wurde ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO geschlossen.
            Beim Aufruf der Seite werden technisch notwendige Daten in Server-Log-Files erfasst:
          </p>
          <ul className="list-disc list-inside mt-3 space-y-1 text-white/70">
            <li>IP-Adresse (gekürzt / anonymisiert)</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Aufgerufene URL und HTTP-Status</li>
            <li>Browser-Typ und Betriebssystem (User-Agent)</li>
            <li>Referrer-URL</li>
          </ul>
          <p className="mt-3">
            <strong className="text-white">Rechts­grundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO
            (berechtigtes Interesse an Sicherheit und Stabilität des Servers). Speicherdauer max. 30 Tage.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            4. Newsletter-Anmeldung
          </h2>
          <p>
            Wenn du dich für den Newsletter anmeldest, verarbeiten wir deine E-Mail-Adresse und die ausgewählte
            Sprache, um dir Informationen zu neuen Drops und Aktionen zu senden.
          </p>
          <ul className="list-disc list-inside mt-3 space-y-1 text-white/70">
            <li>E-Mail-Adresse</li>
            <li>Sprache (DE / EN / ES)</li>
            <li>Zeitpunkt der Anmeldung</li>
          </ul>
          <p className="mt-3">
            <strong className="text-white">Rechts­grundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
            Du kannst deine Einwilligung jederzeit widerrufen — durch eine kurze E-Mail an{" "}
            <a className="text-[#D4AF37] hover:underline" href="mailto:kontakt@vhp-consulting.com">
              kontakt@vhp-consulting.com
            </a>{" "}
            oder durch den Abmeldelink in jeder Newsletter-Mail.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            5. Bestellungen & Zahlungsabwicklung (Shopify)
          </h2>
          <p>
            Käufe werden über unseren Verkaufspartner <strong>Shopify International Limited</strong>{" "}
            (Victoria Buildings, 1–2 Haddington Road, Dublin 4, D04 XN32, Irland) abgewickelt. Beim Klick auf
            „Im Shop ansehen" wirst du zu Shopify weitergeleitet. Dort gelten zusätzlich die Datenschutz­hinweise
            von Shopify:{" "}
            <a
              href="https://www.shopify.com/legal/privacy"
              target="_blank"
              rel="noreferrer"
              className="text-[#D4AF37] hover:underline"
            >
              shopify.com/legal/privacy
            </a>
            . Shopify kann Daten ggf. an Server in die USA übermitteln; die Übermittlung erfolgt auf Grundlage
            von Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO).
          </p>
          <p className="mt-3">
            <strong className="text-white">Rechts­grundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO
            (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            6. Produkt-Druck & Versand (Gelato / Print-on-Demand)
          </h2>
          <p>
            Die Bestellabwicklung (Druck, Veredelung, Versand) erfolgt über unseren Print-on-Demand-Partner
            <strong> Gelato APS</strong> (Toftebakken 9, 3460 Birkerød, Dänemark). Gelato erhält ausschließlich
            die zur Vertragserfüllung notwendigen Daten (Name, Lieferadresse, Bestellinhalt). Die Verarbeitung
            findet innerhalb der EU statt.
          </p>
          <p className="mt-3">
            <strong className="text-white">Rechts­grundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            7. Cookies & Tracking
          </h2>
          <p>
            Wir verwenden technisch notwendige Cookies (z. B. zur Speicherung deiner Sprachauswahl und deiner
            Cookie-Einwilligung im <code className="bg-white/10 px-1 py-0.5 text-sm">localStorage</code>).
            Diese sind zur Bereitstellung der Website erforderlich (Art. 6 Abs. 1 lit. f DSGVO, § 25 Abs. 2 TTDSG).
          </p>
          <p className="mt-3">
            Darüber hinaus setzen wir nach deiner ausdrücklichen Einwilligung (Art. 6 Abs. 1 lit. a DSGVO,
            § 25 Abs. 1 TTDSG) folgende Dienste ein:
          </p>

          <h3 className="font-display text-lg uppercase tracking-wider text-white/90 mt-6 mb-2">
            a) Google Analytics 4
          </h3>
          <p>
            Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Zweck:
            Reichweitenmessung & Optimierung. Speicherdauer: max. 14 Monate. Datentransfer in die USA
            auf Grundlage von Standardvertragsklauseln möglich.{" "}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer"
               className="text-[#D4AF37] hover:underline">
              policies.google.com/privacy
            </a>
          </p>

          <h3 className="font-display text-lg uppercase tracking-wider text-white/90 mt-6 mb-2">
            b) Meta Pixel (Facebook / Instagram)
          </h3>
          <p>
            Anbieter: Meta Platforms Ireland Ltd., 4 Grand Canal Square, Dublin 2, Irland. Zweck: Conversion-
            und Retargeting-Tracking für Werbeanzeigen. Es findet eine gemeinsame Verantwortlichkeit (Art. 26
            DSGVO) mit Meta statt. Datentransfer in die USA auf Grundlage von Standardvertragsklauseln möglich.{" "}
            <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noreferrer"
               className="text-[#D4AF37] hover:underline">
              facebook.com/privacy/policy
            </a>
          </p>

          <h3 className="font-display text-lg uppercase tracking-wider text-white/90 mt-6 mb-2">
            c) TikTok Pixel
          </h3>
          <p>
            Anbieter: TikTok Information Technologies UK Limited, 6th Floor, One London Wall, London,
            EC2Y 5EB, Vereinigtes Königreich. Zweck: Conversion- und Retargeting-Tracking.{" "}
            <a href="https://www.tiktok.com/legal/privacy-policy-eea" target="_blank" rel="noreferrer"
               className="text-[#D4AF37] hover:underline">
              tiktok.com/legal/privacy-policy-eea
            </a>
          </p>

          <p className="mt-6">
            <strong className="text-white">Widerruf:</strong> Du kannst deine Einwilligung jederzeit über
            den Cookie-Banner (Button „Einstellungen ändern" unten links auf der Seite) oder über die
            Browser-Einstellungen widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung
            bleibt davon unberührt.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            8. Deine Rechte
          </h2>
          <p>Du hast jederzeit das Recht auf:</p>
          <ul className="list-disc list-inside mt-3 space-y-1 text-white/70">
            <li>Auskunft (Art. 15 DSGVO)</li>
            <li>Berichtigung (Art. 16 DSGVO)</li>
            <li>Löschung (Art. 17 DSGVO)</li>
            <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Widerspruch (Art. 21 DSGVO)</li>
            <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO) — zuständig: Sächsischer
              Datenschutzbeauftragter, Devrientstraße 5, 01067 Dresden</li>
          </ul>
          <p className="mt-3">
            Anfragen sende bitte an{" "}
            <a className="text-[#D4AF37] hover:underline" href="mailto:kontakt@vhp-consulting.com">
              kontakt@vhp-consulting.com
            </a>
            .
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            9. Speicherdauer
          </h2>
          <p>
            Personenbezogene Daten werden nur so lange gespeichert, wie es zur Erreichung des jeweiligen Zwecks
            erforderlich ist bzw. gesetzliche Aufbewahrungs­pflichten dies vorgeben (i. d. R. 6 oder 10 Jahre
            für handels-/steuerrechtlich relevante Daten gemäß § 257 HGB / § 147 AO).
          </p>
        </div>

        <p className="text-white/40 text-xs">
          Stand: {new Date().toLocaleDateString("de-DE")}
        </p>
      </section>
    </LegalLayout>
  );
}
